/* Price on application (POA).
   - Opens the price request modal (snippets/poa-enquiry-modal.liquid) and fills in the product the customer asked
     about. Buttons can be added to the page later (quick view, filters...), so clicks are delegated from the document.
   - On the contact page, fills in the product when the customer comes from a product's "Contact us" button. */

(function () {
  function fillProduct(container, name, sku, url) {
    var label = container.querySelector('[data-poa-product-label]');

    if (label) {
      label.textContent = sku ? name + ' (SKU: ' + sku + ')' : name;
    }

    [['name', name], ['sku', sku], ['url', url]].forEach(function (field) {
      var input = container.querySelector('[data-poa-field="' + field[0] + '"]');

      if (input) {
        input.value = field[1];
      }
    });
  }

  // Keep the theme's floating labels raised once a field has a value
  document.addEventListener('input', function (event) {
    var field = event.target;

    if (field.classList && field.classList.contains('form__field') && field.closest('#poa-enquiry, [data-poa-contact]')) {
      field.classList.toggle('is-filled', field.value !== '');
    }
  });

  /* Price request modal */

  var dialog = document.getElementById('poa-enquiry');

  if (dialog && typeof dialog.showModal === 'function') {
    var openDialog = function () {
      if (!dialog.open) {
        dialog.showModal();
      }
    };

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-poa-enquiry]');

      if (button) {
        event.preventDefault();

        fillProduct(
          dialog,
          button.getAttribute('data-product-name') || '',
          button.getAttribute('data-product-sku') || '',
          button.getAttribute('data-product-url') || ''
        );

        openDialog();
        return;
      }

      if (event.target.closest('[data-poa-close]') || event.target === dialog) {
        dialog.close();
      }
    });

    // After sending, Shopify reloads the page with "#poa-enquiry-form" in the URL: show the success or error message.
    if (window.location.hash === '#poa-enquiry-form' && dialog.querySelector('[data-poa-posted]')) {
      openDialog();
    }
  }

  /* Contact page */

  var contactBlock = document.querySelector('[data-poa-contact]');
  var params = new URLSearchParams(window.location.search);
  var productName = params.get('poa_product');

  if (contactBlock && productName) {
    var form = contactBlock.closest('form');

    contactBlock.hidden = false;

    contactBlock.querySelectorAll('input').forEach(function (input) {
      input.disabled = false;
    });

    fillProduct(contactBlock, productName, params.get('poa_sku') || '', params.get('poa_url') || '');

    var message = form && form.querySelector('[name="contact[body]"]');

    if (message && message.value === '') {
      var intro = contactBlock.getAttribute('data-poa-message') || '';

      message.value = (intro ? intro + '\n\n' : '') + productName;
      message.classList.add('is-filled');
    }

    // Centred, so the sticky header does not cover the product
    contactBlock.scrollIntoView({ block: 'center' });
  }
})();
